import React from 'react';
import { StyleSheet } from 'react-native';
import { DNABox, DNAButton, DNAText, Iffy } from '@alucio/lux-ui';
import colors from '@alucio/lux-ui/src/theming/themes/alucio/colors';
import SvgErrorIcon from 'src/assets/images/ErrorIcon';

const styles = StyleSheet.create({
  errorMessage: {
    marginTop: 12,
    textAlign: 'center',
    color: colors['color-gray-800'],
  },
  retryButton: {
    marginTop: 20,
  },
})

interface DNAErrorType {
  message?: string,
  actionButtonText?: string,
  actionButtonOnPress?: () => void,
}

const DEFAULT_MESSAGE = 'Something went wrong. Please try again.';

const DNAError: React.FC<DNAErrorType> = (props) => {
  const { message, actionButtonText, actionButtonOnPress } = props;
  return (
    <DNABox fill appearance="col" alignX="center" alignY="center">
      <SvgErrorIcon/>
      <DNAText style={styles.errorMessage}>{message ?? DEFAULT_MESSAGE}</DNAText>
      <Iffy is={actionButtonText}>
        <DNAButton
          appearance="outline"
          status="tertiary"
          onPress={actionButtonOnPress}
          style={styles.retryButton}
          children={actionButtonText}
        />
      </Iffy>
    </DNABox>
  )
}

export default DNAError;
